import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsSortSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.sort
);
